/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ValidateAttestationRequest} from '@cash-web/protos/squareup/cash/deviceintegritly/api/service.pb'
import {ValidateAttestationResponse} from '@cash-web/protos/squareup/cash/deviceintegritly/api/service.pb'


export const validateSafetyNetAttestation = (request: ValidateAttestationRequest, options?: CashRequestOptions) => post<ValidateAttestationRequest, ValidateAttestationResponse>("/2.0/cash/validate-safety-net-attestation", request, {...options, rejectOnError: true })